<template>
<div>
    <Header />
        <Spin size="large" fix v-if="spinShow"></Spin>

    <div id='LoginForm'>
        <div class="container">

            <h1 v-if="status === 0" class="form-heading text-center" style="margin-top:79px;">{{$t('signupwelcome')}}</h1>
            <h1 v-if="status === 1" class="form-heading text-center" style="margin-top:79px;">{{$t('Verify Your Account')}}</h1>

            <div class="login-form" style="margin-top:32px;">
                <div class="main-div" v-if="status === 1" style="padding: 40px 112px 25px 40px;max-width: 56%;">

                    <div>
                        <p class='green  text-align-left'>
                            {{$t('verifysubtitle')}}
                        </p>

                        <p class='gray  text-align-left font-size-12 margin-top-20'>
                            {{$t('verifytip1')}}

                        </p>
                        <ul class='gray  text-align-left font-size-12' style="padding-left:0px;">
                            <li> {{$t('verifytip2')}}</li>

                            <li>{{$t('verifytip3')}}</li>

                            <!-- <li  >如果您已在此电子邮件地址注册了账户，则可以 重制密码。</li> -->

                        </ul>
                        <p class='gray  text-align-left font-size-12'>
                            <!-- 如果您已尝试上述操作但仍未受到我们发送的电子邮件，请联系CoinNewton -->
                        </p>
                    </div>

                </div>

                <div class="main-div" v-if="status === 0">

                    <div>

                        <div class="form-group">
                            <div class="alert alert-danger" v-if="alertDanger != ''" role="alert">{{alertDanger}}</div>
                            <div class="alert alert-success" v-if="alertSuccess != ''" role="alert">{{alertSuccess}}</div>

                            <label for="inputEmail" class='green float-left margin-bottom-15'>{{$t('email')}}</label>

                            <input type="email" readonly class="form-control width-320 height-40  border-green" id="inputEmail" v-model="email" placeholder="Email Address">

                        </div>

                        <div class="form-group">
                            <label for="inputPassword" class='green float-left margin-bottom-15'>{{$t('password')}}</label>


                            <input type="text" style="font-family:password" class="form-control width-320 height-40 margin-bottom-15 border-green" v-model="password" >

                        </div>
                        <div class="form-group">
                            <label for="inputPassword" class='green float-left margin-bottom-15'>{{$t('confirmpw')}}</label>

                            <input type="text" style="font-family:password" @keyup.enter="reg" class="form-control width-320 height-40 margin-bottom-15 border-green" v-model="rePassword" >

                        </div>

                        <button @click="reg" class="bg-green btn btn-primary margin-top-24 margin-bottom-24 width-320">{{$t('signup')}}
                        </button>
                        <!-- <div class="reg-foot">
                            <a class="hover-point" href="javascript:void(0)">{{$t('alreadysu')}}</a>
                            <a href="/login" style="margin-left:-2px;" class="blue">{{$t('login')}}</a>
                        </div> -->

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import settings from '@/utils/settings';
import 'bootstrap';
var md5 = require('md5');
import $ from 'jquery'
import Utils from '@/utils/Utils';
import axios from '@/service/interceptor';
import * as types from '@/store/mutation-types';
import Header from '@/components/common/Header.vue';

export default {
    components: {
        Header,
    },
    data() {
        return {
            spinShow: false,
            email: '',
            lang: Utils.getQueryObject().lang || localStorage.getItem("lang") || 'tr',
            langVal: Utils.getLangVal(Utils.getQueryObject().lang || localStorage.getItem('lang') || 'tr'),
            password: '',
            rePassword: '',
            token: Utils.getQueryObject().token || '',
            alertDanger: '',
            alertSuccess: '',
            arrayOfObjects: ['Türk dili', '中文'],
            object: {
                name: 'Türk dili',
            },
            status: 0
        }
    },

    mounted() {
        var self = this
        console.log(3333434)
        // $('.dropdown-toggle').dropdown()        
        this.email = Utils.getToken(this.token).email;

    },
    methods: {
        switchLanguage(lang) {
            // if (lang === this.lang) return false
            location.href = Utils.changeURLArg(location.href, 'lang', lang)
        },
        reg() {
            var self = this
            self.alertDanger = ''
            self.alertSuccess = ''
            if (!Utils.isEmail(self.email)) {
                return self.alertDanger = self.$t('emailWrong')
            }
            if (!Utils.isPassword(self.password)) {
                return self.alertDanger = self.$t('passwordWrong')
            }
            if (self.password !== self.rePassword) {
                self.alertDanger = self.$t('passwordIsSame')
                return
            }
            self.spinShow = true;
            axios.post(`${settings.HOST}/api/v1` , {
                    cmd: 'register',
                    email: self.email,
                    loginPwd: md5(self.password+settings.salt),
                    token: self.token,
                    lang: 'en',
                }).then(function (data) {
                    self.spinShow = true
                    if (data.data.code === 100002) {
                        self.alertDanger = self.$t('userExits')
                        return
                    }
                    if (data.data.code === 0) {
                          const userToken = {
                            email: self.email,
                            token: data.data.userToken,
                            bttUserid: data.data.bttUserid,
                        }
                        localStorage.setItem('session', JSON.stringify(userToken));
                        self.$store.commit(types.LOGIN, userToken);
                        self.$router.push(`/Balance?token=${self.token}`)
                    } else {
                        self.alertDanger = 'Error'
                    }
                }).catch(function (e) {
                    self.spinShow = true

                    self.alertDanger = 'Error'
                })
        }
    }
}
</script>
<style scoped>
@import 'bootstrap/dist/css/bootstrap.css';
@import '../../static/style/lib.css';
@import '../../static/style/reg.css';
</style>



// WEBPACK FOOTER //
// src/views/Reg.vue